import Vue from "@/main";
import proj4 from "proj4";

let tileSetPlanClip = null;
let currentModelId;
let tilesetBoxClip;
export let graphicLayer; // 矢量图层对象

export function Initialization() {
  graphicLayer = new mars3d.layer.GraphicLayer();
  Vue.$GLOBAL.map.addLayer(graphicLayer);
}

export function addPlanClipThing(modelId, positions, type) {
  let ps;
  if (type == "newRoad") {
    ps = [positions[1], positions[0]];
  } else {
    ps = positions;
  }

  //添加新的剖切效果
  let tilesetLayer = Vue.$GLOBAL.map.getLayer(modelId, "modelId");

  // tilesetLayer.on(mars3d.EventType.click, function (event) {
  //   console.log("单击了模型", event);
  // });

  if (tilesetLayer) {
    if (currentModelId == modelId) {
      if (tileSetPlanClip) {
        tileSetPlanClip.clear();
        // const graphic = new mars3d.graphic.PointEntity({
        //   name: "贴地点",
        //   position: new mars3d.LngLatPoint(ps[0][0], ps[0][1]),
        //   style: {
        //     color: "#ffff00",
        //     pixelSize: 10,
        //     clampToGround: true,
        //     outlineWidth: 0,
        //   },
        //   attr: { remark: "示例3" },
        // });
        // graphicLayer.addGraphic(graphic);
        tileSetPlanClip.positions = ps;
      }
    } else {
      //去除已有剖切效果
      if (tileSetPlanClip && Vue.$GLOBAL.map.hasThing(tileSetPlanClip)) {
        tileSetPlanClip.clear();
        Vue.$GLOBAL.map.removeThing(tileSetPlanClip, true);
      }
      tileSetPlanClip = new mars3d.thing.TilesetPlanClip({
        positions: ps,
        layer: tilesetLayer,
        clipOutSide: false,
        edgeColor: Cesium.Color.GREY,
        edgeWidth: 2.0,
      });

      Vue.$GLOBAL.map.addThing(tileSetPlanClip);
    }
    currentModelId = modelId;
  } else {
    // Vue.$alert("模型ID无效。", "友情提示", {
    //   confirmButtonText: "确定",
    //   type: "warning",
    //   callback: (action) => {},
    // });
    console.log(modelId);
    console.log(Vue.$GLOBAL.map.getLayer(modelId, "modelId"));
    console.log("模型ID无效。");
  }
}

export function colorHide(modelId) {
  let tilesetLayer = Vue.$GLOBAL.map.getLayer(modelId, "modelId");
  if (tilesetLayer) {
    const conditions = [];
    conditions.push(["true", "rgba(255, 255, 255,0)"]);
    tilesetLayer.style = new Cesium.Cesium3DTileStyle({
      color: {
        conditions: conditions,
      },
    });
  }
}
export function colorShow(modelId) {
  let tilesetLayer = Vue.$GLOBAL.map.getLayer(modelId, "modelId");
  if (tilesetLayer) {
    const conditions = [];
    conditions.push(["true", "rgb(255, 255, 255,1)"]);
    tilesetLayer.style = new Cesium.Cesium3DTileStyle({
      color: {
        conditions: conditions,
      },
    });
  }
}

export function getData(x, y, z) {
  // 当前项目的proj4
  const fromProjection = `PROJCS["CGCS2000_3_Degree_GK_CM_114E",GEOGCS["GCS_China_Geodetic_Coordinate_System_2000",DATUM["D_China_2000",SPHEROID["CGCS2000",6378137.0,298.257222101]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["central_meridian",113.75],PARAMETER["false_easting",500000],PARAMETER["false_northing",0],PARAMETER["latitude_of_origin",0],PARAMETER["scale_factor",1],UNIT["metre",1]]`;

  // const fromProjection = `PROJCS["<Custom Projection Coordinate System>",GEOGCS["duyun-10740-900",DATUM["<Custom>",SPHEROID["IAG 1975",6379040,298.257],TOWGS84[-0.905,3.434,1.711,0.571304,-1.284269,3.3371,-0.145978]],PRIMEM["Greenwich",0],UNIT["degree",0.0174532925199433]],PROJECTION["Gauss_Kruger"],PARAMETER["central_meridian",107.666666667],PARAMETER["false_easting",500000],PARAMETER["false_northing",0],PARAMETER["latitude_of_origin",0],PARAMETER["scale_factor",1],UNIT["metre",1]]`;

  //   const fromProjection = `PROJCS["Transverse_Mercator",GEOGCS["GCS_泉夏118度21分",DATUM["D_泉夏118度21分",SPHEROID["CGCS2000",6378137,298.257222101]],PRIMEM["Greenwich",0],UNIT["Degree",0.017453292519943295]],PROJECTION["Transverse_Mercator"],PARAMETER["scale_factor",1],PARAMETER["central_meridian",118.35],PARAMETER["latitude_of_origin",0],PARAMETER["false_easting",500000],PARAMETER["false_northing",0],UNIT["Meter",1]]
  // `;
  // const fromProjection = `PROJCS["<Custom Projection Coordinate System>",GEOGCS["duyun-10740-900",DATUM["<Custom>",SPHEROID["IAG 1975",6379040,298.257]],PRIMEM["Greenwich",0],UNIT["degree",0.0174532925199433]],PROJECTION["Gauss_Kruger"],PARAMETER["central_meridian",107.666666667],PARAMETER["false_easting",500000],PARAMETER["false_northing",0],PARAMETER["latitude_of_origin",0],PARAMETER["scale_factor",1],UNIT["metre",1]]`;

  let arr = [Number(x), Number(y), z];

  // 固定WGS84
  const toProjection = `GEOGCS["WGS 84",DATUM["WGS_1984",SPHEROID["WGS 84",6378137,298.257223563,AUTHORITY["EPSG","7030"]],
                                  AUTHORITY["EPSG", "6326"]], PRIMEM["Greenwich", 0, AUTHORITY["EPSG", "8901"]],
                                  UNIT["degree", 0.0174532925199433, AUTHORITY["EPSG", "9122"]], AUTHORITY["EPSG", "4326"]]`;

  // proj4存在
  if (fromProjection) {
    // 转换出坐标
    const proj4List = proj4(fromProjection, toProjection, arr);
    return proj4List;
  }
}

export function arrChange(num, arr) {
  const newArr = [];
  while (arr.length > 0) {
    newArr.push(arr.splice(0, num));
  }
  return newArr;
}
export function arrChange2(num, arr) {
  const newArr = [];
  while (arr.length > 0) {
    let list = arr.splice(0, num);
    list = [...list[0], ...list[1]];
    newArr.push(list);
  }
  return newArr;
}

export function addDemoGraphic1(positionss) {
  console.log(positionss, "positionsspositionsspositionsspositionss");
  const graphic = new mars3d.graphic.PolylineEntity({
    positions: positionss,
    style: {
      width: 5,
      color: "#3388ff",
    },
    attr: { remark: "示例1" },
  });
  graphicLayer.addGraphic(graphic);
}

export function cheshi() {
  let tilesetLayer = Vue.$GLOBAL.map.getLayer(
    "NewNode-717ae466-57e5-420b-bda8-87a571535a7a",
    "modelId"
  );
  let a = new mars3d.thing.TilesetClip({
    layer: tilesetLayer,
    area: [
      {
        positions: [
          [113.67589535, 23.01554414, 30],
          [113.67650068, 23.01477066, 30],
          [113.67620814, 23.01405857, 30],
          [113.67554723, 23.01493589, 30],
        ],
      },
    ],
    clipOutSide: true,
  });
  console.log(a, "aaaaaaaaa");
  Vue.$GLOBAL.map.addThing(a);
}
